<template>
  <v-app class="bgLightGreen boiler-page customDropdown" id="inspire">
    <Header back header-text="lng_user_title"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    >
    </flash-message>
    <v-container fluid v-if="userMenu">
      <app-menu page-name="UserAcc"></app-menu>
      <v-btn color="blue-grey" class="white--text ml-4" @click="openMap">
        {{ "lng_update_mac_loc" | translate }}
        <v-icon right dark>room</v-icon>
      </v-btn>
      <v-layout row wrap justify-center>
        <v-flex
          v-for="subMenu in userMenu.menu.submenu"
          :key="subMenu['@attributes'].txtid"
          xs12
          md6
          class="px-4 panel-block"
        >
          <sub-menu
            v-if="subMenu && userMenuData"
            :sub-menu="subMenu"
            :sub-menu-data="userMenuData"
            :sub-menu-select-data="userMenu.menu.fieldsets.fieldset"
            :response-alert="setResponseAlert"
            :sub-menu-output-setting="filteredOutputSettings"
          ></sub-menu>
        </v-flex>
        <!-- <v-flex xs12 md6 class="px-4 panel-block">
          <payment-invoices-menu
            v-if="expiryFlag !== '3'"
            :payment-invoices="invoices"
          />
        </v-flex> -->
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import Menu from "../components/menus/Menu";
import SubMenu from "../components/SubMenu";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import { translate } from "../common/HelperFunctions";
import router from "../router.js";
// import PaymentInvoicesMenu from "../components/PaymentInvoicesMenu";

export default {
  components: {
    Header,
    SubMenu,
    FlashMessage,
    appMenu: Menu
  },
  data: () => ({
    userMenu: undefined,
    userMenuData: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    outputSettings: undefined,
    filteredOutputSettings: [],
    pageRefreshTime: 30,
    timerKey: 0,
    invoices: undefined,
    expiryFlag: 2
  }),
  async created() {
    // start page loading component
    this.expiryFlag = localStorage.getItem("expiryFlag");
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenu = await GlobalService.getMenu("user", this.getUser.token);
      this.userMenuData = await GlobalService.getMenuData(
        "user",
        this.getUser.token
      );
      // this.invoices = await GlobalService.getPaymentInvoices(
      //   this.getUser.token
      // );
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    openMap() {
      router.push("/system/settings/map");
    }
  }
};
</script>
<style>
.customDropdown .v-select__selections * {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 140px;
}
.v-list__tile,
.v-list__tile__title {
  cursor: pointer;
  height: auto !important;
  white-space: normal !important;
  padding: 7px;
}
.v-menu__content {
  max-width: 350px;
}
</style>
